;(function () {
  angular.module('contrast.score').controller('csScoreCtrl', csScoreCtrl)

  function csScoreCtrl(SCORE_TYPE) {
    'ngInject'

    var vm = this

    var customTooltipTemplateUrl =
      'views/tooltips/score/customScoreTooltip.html'
    var overallTooltipTemplateUrl =
      'views/tooltips/score/overallScoreTooltip.html'
    var libraryTooltipTemplateUrl =
      'views/tooltips/score/libraryScoreTooltip.html'
    var protectTooltipTemplateUrl =
      'views/tooltips/score/protectScoreTooltip.html'

    angular.extend(vm, {
      determineTooltip: determineTooltip
    })

    function determineTooltip() {
      if (vm.scoreType == SCORE_TYPE.OVERALL) {
        return overallTooltipTemplateUrl
      } else if (vm.scoreType == SCORE_TYPE.LIBRARY) {
        return libraryTooltipTemplateUrl
      } else if (vm.scoreType == SCORE_TYPE.PROTECT) {
        return protectTooltipTemplateUrl
      } else {
        return customTooltipTemplateUrl
      }
    }
  }
})()
